import axiosInstance from './AxiosClient';
import { EMessageType, UserApi } from '../data/Constants';
import { showToastMessage } from '../services/ToastHelper';
import { t } from 'i18next';

export const getUserDetails = async () => {
  try {
    const response = await axiosInstance.get(UserApi.GetUser);
    showToastMessage(EMessageType.Success, t('message.success.getUser'));
    return response;
  } catch (err) {
    showToastMessage(EMessageType.Error, t('message.error.getUser'));
    return err;
  }
};
